/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  AccountSummaryDto,
  BenefitsResponse,
  GetMeBenefitsAutocompleteV1Params,
  GetMeBenefitsV1Params,
  GetMeOrdersV1Params,
  GetMeReservationRequestsV1Params,
  GetMeReservationsV1Params,
  GetMeUpcomingReservationsV1Params,
  InvoiceSummaryDto,
  InvoiceUrlDto,
  MeDto,
  MembershipAutoRenewalDto,
  MembershipDto,
  MembershipUpgradeRequestDto,
  OrderDetailDto,
  OrderSummaryDtoPagedResult,
  ProblemDetails,
  ReservationDetailDto,
  ReservationShareDto,
  ReservationSummaryDto,
  ReservationSummaryDtoPagedResult,
  SetMembershipAutoRenewalRequest,
  ShopOrderSummaryDto,
  UpdatePersonalizedFashionInterestRequest,
  UpdateProfileRequest,
  UploadPhotoRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeV1Response200 = {
  data: MeDto
  status: 200
}

export type getMeV1Response401 = {
  data: void
  status: 401
}

export type getMeV1Response404 = {
  data: void
  status: 404
}

export type getMeV1ResponseSuccess = (getMeV1Response200) & {
  headers: Headers;
};
export type getMeV1ResponseError = (getMeV1Response401 | getMeV1Response404) & {
  headers: Headers;
};

export type getMeV1Response = (getMeV1ResponseSuccess | getMeV1ResponseError)

export const getGetMeV1Url = () => {




  return `/api/v1/me`
}

/**
 * Returns the Customer profile for the authenticated user
 * @summary Get current user's profile
 */
export const getMeV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeV1Response> => {

  return customFetch<getMeV1Response>(getGetMeV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type deleteMeAccountV1Response204 = {
  data: void
  status: 204
}

export type deleteMeAccountV1Response401 = {
  data: void
  status: 401
}

export type deleteMeAccountV1Response404 = {
  data: void
  status: 404
}

export type deleteMeAccountV1ResponseSuccess = (deleteMeAccountV1Response204) & {
  headers: Headers;
};
export type deleteMeAccountV1ResponseError = (deleteMeAccountV1Response401 | deleteMeAccountV1Response404) & {
  headers: Headers;
};

export type deleteMeAccountV1Response = (deleteMeAccountV1ResponseSuccess | deleteMeAccountV1ResponseError)

export const getDeleteMeAccountV1Url = () => {




  return `/api/v1/me`
}

/**
 * Soft-deletes and anonymizes the local account, clears the entraId on Salesforce (the CRM record is preserved), and deletes the Entra user. Irreversible. External-system failures do not block local erasure — they are flagged for retry.
 * @summary Delete the authenticated user's account
 */
export const deleteMeAccountV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<deleteMeAccountV1Response> => {

  return customFetch<deleteMeAccountV1Response>(getDeleteMeAccountV1Url(),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type getMeBenefitsV1Response200 = {
  data: BenefitsResponse
  status: 200
}

export type getMeBenefitsV1Response401 = {
  data: void
  status: 401
}

export type getMeBenefitsV1ResponseSuccess = (getMeBenefitsV1Response200) & {
  headers: Headers;
};
export type getMeBenefitsV1ResponseError = (getMeBenefitsV1Response401) & {
  headers: Headers;
};

export type getMeBenefitsV1Response = (getMeBenefitsV1ResponseSuccess | getMeBenefitsV1ResponseError)

export const getGetMeBenefitsV1Url = (params?: GetMeBenefitsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/benefits?${stringifiedParams}` : `/api/v1/me/benefits`
}

/**
 * Returns the benefits applicable to the authenticated customer — the union of the
 * benefits granted by their active membership tier(s) and their ownership(s) — plus the distinct filter options
 * (groups, categories, locations) present in that set.
 *
 * Query Parameters (all optional):
 * - group: filter by benefit group node key, GUID (e.g. Inside JNcQUOI / Partnerships)
 * - category: filter by category node key, GUID (e.g. Stays, Dining)
 * - location: filter by location node key, GUID
 * - query: free-text search across name, description, group, location and category (accent/case-insensitive, AND tokens)
 * @summary Get current user's membership benefits
 */
export const getMeBenefitsV1 = async (params?: GetMeBenefitsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeBenefitsV1Response> => {

  return customFetch<getMeBenefitsV1Response>(getGetMeBenefitsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeBenefitsAutocompleteV1Response200 = {
  data: string[]
  status: 200
}

export type getMeBenefitsAutocompleteV1Response401 = {
  data: void
  status: 401
}

export type getMeBenefitsAutocompleteV1ResponseSuccess = (getMeBenefitsAutocompleteV1Response200) & {
  headers: Headers;
};
export type getMeBenefitsAutocompleteV1ResponseError = (getMeBenefitsAutocompleteV1Response401) & {
  headers: Headers;
};

export type getMeBenefitsAutocompleteV1Response = (getMeBenefitsAutocompleteV1ResponseSuccess | getMeBenefitsAutocompleteV1ResponseError)

export const getGetMeBenefitsAutocompleteV1Url = (params?: GetMeBenefitsAutocompleteV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/benefits/autocomplete?${stringifiedParams}` : `/api/v1/me/benefits/autocomplete`
}

/**
 * Typeahead suggestions for the benefit search box: benefit titles, location and
 * category names from the customer's applicable benefits whose normalized form starts with the query (prefix
 * match, accent/case-insensitive). Distinct from the history-based suggestions, which the client owns.
 *
 * Query Parameters:
 * - query: the partial term being typed (required; blank returns an empty list)
 * - take: max results, default 8, clamped to 1..20
 * @summary Autocomplete benefit search terms
 */
export const getMeBenefitsAutocompleteV1 = async (params?: GetMeBenefitsAutocompleteV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeBenefitsAutocompleteV1Response> => {

  return customFetch<getMeBenefitsAutocompleteV1Response>(getGetMeBenefitsAutocompleteV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeMembershipV1Response200 = {
  data: MembershipDto
  status: 200
}

export type getMeMembershipV1Response401 = {
  data: void
  status: 401
}

export type getMeMembershipV1ResponseSuccess = (getMeMembershipV1Response200) & {
  headers: Headers;
};
export type getMeMembershipV1ResponseError = (getMeMembershipV1Response401) & {
  headers: Headers;
};

export type getMeMembershipV1Response = (getMeMembershipV1ResponseSuccess | getMeMembershipV1ResponseError)

export const getGetMeMembershipV1Url = () => {




  return `/api/v1/me/membership`
}

/**
 * Returns the active membership tier for the authenticated user, or null if none.
 * @summary Get current user's active membership
 */
export const getMeMembershipV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeMembershipV1Response> => {

  return customFetch<getMeMembershipV1Response>(getGetMeMembershipV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeMembershipAutoRenewalV1Response200 = {
  data: MembershipAutoRenewalDto
  status: 200
}

export type getMeMembershipAutoRenewalV1Response401 = {
  data: void
  status: 401
}

export type getMeMembershipAutoRenewalV1Response404 = {
  data: void
  status: 404
}

export type getMeMembershipAutoRenewalV1ResponseSuccess = (getMeMembershipAutoRenewalV1Response200) & {
  headers: Headers;
};
export type getMeMembershipAutoRenewalV1ResponseError = (getMeMembershipAutoRenewalV1Response401 | getMeMembershipAutoRenewalV1Response404) & {
  headers: Headers;
};

export type getMeMembershipAutoRenewalV1Response = (getMeMembershipAutoRenewalV1ResponseSuccess | getMeMembershipAutoRenewalV1ResponseError)

export const getGetMeMembershipAutoRenewalV1Url = () => {




  return `/api/v1/me/membership/auto-renewal`
}

/**
 * What the "Allow automatic membership renewal" switch should show: whether it is on, what
 * would be charged and when, and whether the member has a card on file.
 *
 * hasPaymentMethod false is why the switch cannot be turned on — send the member to add a
 * card first rather than letting them toggle into an error.
 * @summary Automatic membership renewal — current state
 */
export const getMeMembershipAutoRenewalV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeMembershipAutoRenewalV1Response> => {

  return customFetch<getMeMembershipAutoRenewalV1Response>(getGetMeMembershipAutoRenewalV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type setMeMembershipAutoRenewalV1Response200 = {
  data: MembershipAutoRenewalDto
  status: 200
}

export type setMeMembershipAutoRenewalV1Response401 = {
  data: void
  status: 401
}

export type setMeMembershipAutoRenewalV1Response404 = {
  data: void
  status: 404
}

export type setMeMembershipAutoRenewalV1Response409 = {
  data: void
  status: 409
}

export type setMeMembershipAutoRenewalV1Response422 = {
  data: void
  status: 422
}

export type setMeMembershipAutoRenewalV1Response503 = {
  data: void
  status: 503
}

export type setMeMembershipAutoRenewalV1ResponseSuccess = (setMeMembershipAutoRenewalV1Response200) & {
  headers: Headers;
};
export type setMeMembershipAutoRenewalV1ResponseError = (setMeMembershipAutoRenewalV1Response401 | setMeMembershipAutoRenewalV1Response404 | setMeMembershipAutoRenewalV1Response409 | setMeMembershipAutoRenewalV1Response422 | setMeMembershipAutoRenewalV1Response503) & {
  headers: Headers;
};

export type setMeMembershipAutoRenewalV1Response = (setMeMembershipAutoRenewalV1ResponseSuccess | setMeMembershipAutoRenewalV1ResponseError)

export const getSetMeMembershipAutoRenewalV1Url = () => {




  return `/api/v1/me/membership/auto-renewal`
}

/**
 * Turning it ON creates a Stripe subscription that charges the membership quota on its
 * renewal date, using the member's saved card. Nothing is charged now.
 *
 * Turning it OFF cancels that subscription immediately — nothing has been charged, so
 * there is no paid period to see out.
 *
 * Refusals, each with its own screen:
 * - 409 membership_payment_method_required — no saved card. Open the card screen; this is
 *   the only one the app acts on rather than just reports.
 * - 404 membership_not_found — no active membership to renew.
 * - 422 membership_quota_unavailable — the membership carries no quota, so there is no
 *   amount to charge. Not treated as free.
 * - 422 membership_renewal_date_unavailable — no renewal date, or it has already passed.
 * - 503 membership_subscription_failed — Stripe refused; transient, worth retrying.
 * @summary Turn automatic membership renewal on or off
 */
export const setMeMembershipAutoRenewalV1 = async (setMembershipAutoRenewalRequest: SetMembershipAutoRenewalRequest, options?: Parameters<typeof customFetch>[1]): Promise<setMeMembershipAutoRenewalV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setMeMembershipAutoRenewalV1Response>(getSetMeMembershipAutoRenewalV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setMembershipAutoRenewalRequest)
  }
);}


export type requestMeMembershipUpgradeV1Response200 = {
  data: MembershipUpgradeRequestDto
  status: 200
}

export type requestMeMembershipUpgradeV1Response400 = {
  data: void
  status: 400
}

export type requestMeMembershipUpgradeV1Response401 = {
  data: void
  status: 401
}

export type requestMeMembershipUpgradeV1Response422 = {
  data: void
  status: 422
}

export type requestMeMembershipUpgradeV1Response503 = {
  data: void
  status: 503
}

export type requestMeMembershipUpgradeV1ResponseSuccess = (requestMeMembershipUpgradeV1Response200) & {
  headers: Headers;
};
export type requestMeMembershipUpgradeV1ResponseError = (requestMeMembershipUpgradeV1Response400 | requestMeMembershipUpgradeV1Response401 | requestMeMembershipUpgradeV1Response422 | requestMeMembershipUpgradeV1Response503) & {
  headers: Headers;
};

export type requestMeMembershipUpgradeV1Response = (requestMeMembershipUpgradeV1ResponseSuccess | requestMeMembershipUpgradeV1ResponseError)

export const getRequestMeMembershipUpgradeV1Url = () => {




  return `/api/v1/me/membership/upgrade-request`
}

/**
 * Submits an upgrade request — creates an Opportunity in Salesforce for Customer Service
 * to pick up. Nothing is charged: the tier, the price and the payment are all settled
 * with the member afterwards, outside the app.
 *
 * Takes no body. The tier being asked for is derived from the one the member holds (the
 * next one up), because the screen is a confirmation and offers no choice. A member
 * already at the top tier still gets a request through.
 *
 * REQUIRES an `Idempotency-Key` header (any UUID, one per attempt). Without it the
 * request is refused with 400. Salesforce cannot de-duplicate Opportunities, so a double
 * tap would otherwise leave two for someone to close by hand; repeating the same key
 * replays the first answer instead.
 *
 * Refusals:
 * - 400 — the `Idempotency-Key` header is missing.
 * - 422 membership_upgrade_refused — Salesforce rejected it. Repeating changes nothing.
 * - 503 membership_upgrade_failed — could not be delivered. Nothing was created; safe to
 *   try again, with a NEW key.
 * @summary Ask to upgrade the membership
 */
export const requestMeMembershipUpgradeV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<requestMeMembershipUpgradeV1Response> => {

  return customFetch<requestMeMembershipUpgradeV1Response>(getRequestMeMembershipUpgradeV1Url(),
  {
    ...options,
    method: 'POST'


  }
);}


export type getMeOrdersV1Response200 = {
  data: OrderSummaryDtoPagedResult
  status: 200
}

export type getMeOrdersV1Response401 = {
  data: void
  status: 401
}

export type getMeOrdersV1ResponseSuccess = (getMeOrdersV1Response200) & {
  headers: Headers;
};
export type getMeOrdersV1ResponseError = (getMeOrdersV1Response401) & {
  headers: Headers;
};

export type getMeOrdersV1Response = (getMeOrdersV1ResponseSuccess | getMeOrdersV1ResponseError)

export const getGetMeOrdersV1Url = (params?: GetMeOrdersV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/orders?${stringifiedParams}` : `/api/v1/me/orders`
}

/**
 * Returns paginated orders for the authenticated user.
 *
 * Query Parameters:
 * - page: Page number (default: 1)
 * - pageSize: Items per page (default: 20, max: 100)
 * - status: Filter by status (Draft, Completed, Cancelled, etc.)
 * - source: Filter by source system (cpi, mews, sevenrooms)
 * - fromDate: Filter orders from this date (YYYY-MM-DD)
 * - toDate: Filter orders until this date (YYYY-MM-DD)
 * @summary Get current user's orders (paginated)
 */
export const getMeOrdersV1 = async (params?: GetMeOrdersV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeOrdersV1Response> => {

  return customFetch<getMeOrdersV1Response>(getGetMeOrdersV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeOrderByIdV1Response200 = {
  data: OrderDetailDto
  status: 200
}

export type getMeOrderByIdV1Response401 = {
  data: void
  status: 401
}

export type getMeOrderByIdV1Response404 = {
  data: void
  status: 404
}

export type getMeOrderByIdV1ResponseSuccess = (getMeOrderByIdV1Response200) & {
  headers: Headers;
};
export type getMeOrderByIdV1ResponseError = (getMeOrderByIdV1Response401 | getMeOrderByIdV1Response404) & {
  headers: Headers;
};

export type getMeOrderByIdV1Response = (getMeOrderByIdV1ResponseSuccess | getMeOrderByIdV1ResponseError)

export const getGetMeOrderByIdV1Url = (id: string,) => {




  return `/api/v1/me/orders/${id}`
}

/**
 * Returns a specific order with detail. User can only access their own orders.
 * @summary Get single order by ID
 */
export const getMeOrderByIdV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeOrderByIdV1Response> => {

  return customFetch<getMeOrderByIdV1Response>(getGetMeOrderByIdV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeOrderInvoicesV1Response200 = {
  data: InvoiceSummaryDto[]
  status: 200
}

export type getMeOrderInvoicesV1Response401 = {
  data: void
  status: 401
}

export type getMeOrderInvoicesV1Response404 = {
  data: void
  status: 404
}

export type getMeOrderInvoicesV1ResponseSuccess = (getMeOrderInvoicesV1Response200) & {
  headers: Headers;
};
export type getMeOrderInvoicesV1ResponseError = (getMeOrderInvoicesV1Response401 | getMeOrderInvoicesV1Response404) & {
  headers: Headers;
};

export type getMeOrderInvoicesV1Response = (getMeOrderInvoicesV1ResponseSuccess | getMeOrderInvoicesV1ResponseError)

export const getGetMeOrderInvoicesV1Url = (id: string,) => {




  return `/api/v1/me/orders/${id}/invoices`
}

/**
 * Returns all invoices for the given order. The order must belong to the authenticated user.
 * @summary List invoices for an order
 */
export const getMeOrderInvoicesV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeOrderInvoicesV1Response> => {

  return customFetch<getMeOrderInvoicesV1Response>(getGetMeOrderInvoicesV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeInvoiceUrlV1Response200 = {
  data: InvoiceUrlDto
  status: 200
}

export type getMeInvoiceUrlV1Response202 = {
  data: void
  status: 202
}

export type getMeInvoiceUrlV1Response401 = {
  data: void
  status: 401
}

export type getMeInvoiceUrlV1Response404 = {
  data: void
  status: 404
}

export type getMeInvoiceUrlV1ResponseSuccess = (getMeInvoiceUrlV1Response200 | getMeInvoiceUrlV1Response202) & {
  headers: Headers;
};
export type getMeInvoiceUrlV1ResponseError = (getMeInvoiceUrlV1Response401 | getMeInvoiceUrlV1Response404) & {
  headers: Headers;
};

export type getMeInvoiceUrlV1Response = (getMeInvoiceUrlV1ResponseSuccess | getMeInvoiceUrlV1ResponseError)

export const getGetMeInvoiceUrlV1Url = (id: string,
    invoiceId: string,) => {




  return `/api/v1/me/orders/${id}/invoices/${invoiceId}/url`
}

/**
 * Returns a 15-minute SAS URL to download the invoice PDF. The invoice must belong to the authenticated user.
 * @summary Get download URL for a specific invoice
 */
export const getMeInvoiceUrlV1 = async (id: string,
    invoiceId: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeInvoiceUrlV1Response> => {

  return customFetch<getMeInvoiceUrlV1Response>(getGetMeInvoiceUrlV1Url(id,invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeShopOrderSummaryV1Response200 = {
  data: ShopOrderSummaryDto
  status: 200
}

export type getMeShopOrderSummaryV1Response401 = {
  data: void
  status: 401
}

export type getMeShopOrderSummaryV1Response404 = {
  data: void
  status: 404
}

export type getMeShopOrderSummaryV1ResponseSuccess = (getMeShopOrderSummaryV1Response200) & {
  headers: Headers;
};
export type getMeShopOrderSummaryV1ResponseError = (getMeShopOrderSummaryV1Response401 | getMeShopOrderSummaryV1Response404) & {
  headers: Headers;
};

export type getMeShopOrderSummaryV1Response = (getMeShopOrderSummaryV1ResponseSuccess | getMeShopOrderSummaryV1ResponseError)

export const getGetMeShopOrderSummaryV1Url = (id: string,) => {




  return `/api/v1/me/orders/${id}/summary`
}

/**
 * Returns the confirmation summary of a closed shop order (Order Confirmed screen): order number, receipt, date, subtotal/shipping/discount/total and the snapshotted lines. 404 for non-shop orders or orders of another user.
 * @summary Get shop order confirmation summary
 */
export const getMeShopOrderSummaryV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeShopOrderSummaryV1Response> => {

  return customFetch<getMeShopOrderSummaryV1Response>(getGetMeShopOrderSummaryV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type updateMePersonalizedFashionInterestV1Response200 = {
  data: MeDto
  status: 200
}

export type updateMePersonalizedFashionInterestV1Response401 = {
  data: void
  status: 401
}

export type updateMePersonalizedFashionInterestV1Response404 = {
  data: void
  status: 404
}

export type updateMePersonalizedFashionInterestV1ResponseSuccess = (updateMePersonalizedFashionInterestV1Response200) & {
  headers: Headers;
};
export type updateMePersonalizedFashionInterestV1ResponseError = (updateMePersonalizedFashionInterestV1Response401 | updateMePersonalizedFashionInterestV1Response404) & {
  headers: Headers;
};

export type updateMePersonalizedFashionInterestV1Response = (updateMePersonalizedFashionInterestV1ResponseSuccess | updateMePersonalizedFashionInterestV1ResponseError)

export const getUpdateMePersonalizedFashionInterestV1Url = () => {




  return `/api/v1/me/personalized-fashion-interest`
}

/**
 * Updates the customer's personalized fashion interest field.
 * @summary Update personalized fashion interest
 */
export const updateMePersonalizedFashionInterestV1 = async (updatePersonalizedFashionInterestRequest: UpdatePersonalizedFashionInterestRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateMePersonalizedFashionInterestV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateMePersonalizedFashionInterestV1Response>(getUpdateMePersonalizedFashionInterestV1Url(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePersonalizedFashionInterestRequest)
  }
);}


export type uploadMePhotoV1Response200 = {
  data: MeDto
  status: 200
}

export type uploadMePhotoV1Response400 = {
  data: void
  status: 400
}

export type uploadMePhotoV1Response401 = {
  data: void
  status: 401
}

export type uploadMePhotoV1Response404 = {
  data: void
  status: 404
}

export type uploadMePhotoV1ResponseSuccess = (uploadMePhotoV1Response200) & {
  headers: Headers;
};
export type uploadMePhotoV1ResponseError = (uploadMePhotoV1Response400 | uploadMePhotoV1Response401 | uploadMePhotoV1Response404) & {
  headers: Headers;
};

export type uploadMePhotoV1Response = (uploadMePhotoV1ResponseSuccess | uploadMePhotoV1ResponseError)

export const getUploadMePhotoV1Url = () => {




  return `/api/v1/me/photo`
}

/**
 * Accepts a base64-encoded image. Returns the updated account profile. Storage integration pending.
 * @summary Upload profile photo
 */
export const uploadMePhotoV1 = async (uploadPhotoRequest: UploadPhotoRequest, options?: Parameters<typeof customFetch>[1]): Promise<uploadMePhotoV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<uploadMePhotoV1Response>(getUploadMePhotoV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadPhotoRequest)
  }
);}


export type updateMeProfileV1Response200 = {
  data: MeDto
  status: 200
}

export type updateMeProfileV1Response401 = {
  data: void
  status: 401
}

export type updateMeProfileV1Response404 = {
  data: void
  status: 404
}

export type updateMeProfileV1ResponseSuccess = (updateMeProfileV1Response200) & {
  headers: Headers;
};
export type updateMeProfileV1ResponseError = (updateMeProfileV1Response401 | updateMeProfileV1Response404) & {
  headers: Headers;
};

export type updateMeProfileV1Response = (updateMeProfileV1ResponseSuccess | updateMeProfileV1ResponseError)

export const getUpdateMeProfileV1Url = () => {




  return `/api/v1/me/profile`
}

/**
 * Updates whitelisted fields (preferredName, otherEmail, otherPhone). All fields are optional. Propagates to MuleSoft; otherPhone is also persisted locally.
 * @summary Update profile fields
 */
export const updateMeProfileV1 = async (updateProfileRequest: UpdateProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateMeProfileV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateMeProfileV1Response>(getUpdateMeProfileV1Url(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProfileRequest)
  }
);}


export type getMeReservationRequestsV1Response200 = {
  data: ReservationSummaryDtoPagedResult
  status: 200
}

export type getMeReservationRequestsV1Response401 = {
  data: void
  status: 401
}

export type getMeReservationRequestsV1ResponseSuccess = (getMeReservationRequestsV1Response200) & {
  headers: Headers;
};
export type getMeReservationRequestsV1ResponseError = (getMeReservationRequestsV1Response401) & {
  headers: Headers;
};

export type getMeReservationRequestsV1Response = (getMeReservationRequestsV1ResponseSuccess | getMeReservationRequestsV1ResponseError)

export const getGetMeReservationRequestsV1Url = (params?: GetMeReservationRequestsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/reservation-requests?${stringifiedParams}` : `/api/v1/me/reservation-requests`
}

/**
 * Returns paginated reservation requests (Pending) for the authenticated user. A reservation request is a SevenRooms booking that is still awaiting venue staff approval — it is conceptually distinct from a confirmed reservation and lives in its own listing. Same enrichment as /me/reservations.
 *
 * Query Parameters:
 * - page: Page number (default: 1)
 * - pageSize: Items per page (default: 20, max: 100)
 * - source: Filter by source code (typically "sevenrooms")
 * - serviceType: Filter by service type
 * - fromDate: Filter from this date (YYYY-MM-DD)
 * - toDate: Filter until this date (YYYY-MM-DD)
 * @summary Get current user's reservation requests (paginated)
 */
export const getMeReservationRequestsV1 = async (params?: GetMeReservationRequestsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeReservationRequestsV1Response> => {

  return customFetch<getMeReservationRequestsV1Response>(getGetMeReservationRequestsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeReservationsV1Response200 = {
  data: ReservationSummaryDtoPagedResult
  status: 200
}

export type getMeReservationsV1Response401 = {
  data: void
  status: 401
}

export type getMeReservationsV1ResponseSuccess = (getMeReservationsV1Response200) & {
  headers: Headers;
};
export type getMeReservationsV1ResponseError = (getMeReservationsV1Response401) & {
  headers: Headers;
};

export type getMeReservationsV1Response = (getMeReservationsV1ResponseSuccess | getMeReservationsV1ResponseError)

export const getGetMeReservationsV1Url = (params?: GetMeReservationsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/reservations?${stringifiedParams}` : `/api/v1/me/reservations`
}

/**
 * Returns paginated reservations for the authenticated user, enriched with venue + service-category content from the CMS (culture-aware via Accept-Language). Excludes Pending reservation requests — those are served by /me/reservation-requests.
 *
 * Query Parameters:
 * - page: Page number (default: 1)
 * - pageSize: Items per page (default: 20, max: 100)
 * - source: Filter by source code (e.g. "mews", "sevenrooms")
 * - status: Filter by reservation status (e.g. "Confirmed", "Cancelled")
 * - serviceType: Filter by service type (e.g. "Restaurant", "Bar", "Room", "Spa")
 * - fromDate: Filter reservations from this date (YYYY-MM-DD)
 * - toDate: Filter reservations until this date (YYYY-MM-DD)
 * @summary Get current user's reservations (paginated)
 */
export const getMeReservationsV1 = async (params?: GetMeReservationsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeReservationsV1Response> => {

  return customFetch<getMeReservationsV1Response>(getGetMeReservationsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeReservationByIdV1Response200 = {
  data: ReservationDetailDto
  status: 200
}

export type getMeReservationByIdV1Response401 = {
  data: void
  status: 401
}

export type getMeReservationByIdV1Response404 = {
  data: void
  status: 404
}

export type getMeReservationByIdV1ResponseSuccess = (getMeReservationByIdV1Response200) & {
  headers: Headers;
};
export type getMeReservationByIdV1ResponseError = (getMeReservationByIdV1Response401 | getMeReservationByIdV1Response404) & {
  headers: Headers;
};

export type getMeReservationByIdV1Response = (getMeReservationByIdV1ResponseSuccess | getMeReservationByIdV1ResponseError)

export const getGetMeReservationByIdV1Url = (id: string,) => {




  return `/api/v1/me/reservations/${id}`
}

/**
 * Returns a specific reservation with linked orders, enriched with venue + service-category content from the CMS (culture-aware via Accept-Language). User can only access their own reservations.
 * @summary Get single reservation by ID
 */
export const getMeReservationByIdV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeReservationByIdV1Response> => {

  return customFetch<getMeReservationByIdV1Response>(getGetMeReservationByIdV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeReservationByShareCodeV1Response200 = {
  data: ReservationDetailDto
  status: 200
}

export type getMeReservationByShareCodeV1Response401 = {
  data: ProblemDetails
  status: 401
}

export type getMeReservationByShareCodeV1Response404 = {
  data: void
  status: 404
}

export type getMeReservationByShareCodeV1ResponseSuccess = (getMeReservationByShareCodeV1Response200) & {
  headers: Headers;
};
export type getMeReservationByShareCodeV1ResponseError = (getMeReservationByShareCodeV1Response401 | getMeReservationByShareCodeV1Response404) & {
  headers: Headers;
};

export type getMeReservationByShareCodeV1Response = (getMeReservationByShareCodeV1ResponseSuccess | getMeReservationByShareCodeV1ResponseError)

export const getGetMeReservationByShareCodeV1Url = (id: string,
    code: string,) => {




  return `/api/v1/me/reservations/${id}/${code}`
}

/**
 * Returns the reservation detail if the share code matches. No ownership validation — the code is the authorisation.
 * @summary Get reservation via share code
 */
export const getMeReservationByShareCodeV1 = async (id: string,
    code: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeReservationByShareCodeV1Response> => {

  return customFetch<getMeReservationByShareCodeV1Response>(getGetMeReservationByShareCodeV1Url(id,code),
  {
    ...options,
    method: 'GET'


  }
);}


export type cancelMeReservationV1Response204 = {
  data: void
  status: 204
}

export type cancelMeReservationV1Response401 = {
  data: void
  status: 401
}

export type cancelMeReservationV1Response404 = {
  data: void
  status: 404
}

export type cancelMeReservationV1Response409 = {
  data: void
  status: 409
}

export type cancelMeReservationV1ResponseSuccess = (cancelMeReservationV1Response204) & {
  headers: Headers;
};
export type cancelMeReservationV1ResponseError = (cancelMeReservationV1Response401 | cancelMeReservationV1Response404 | cancelMeReservationV1Response409) & {
  headers: Headers;
};

export type cancelMeReservationV1Response = (cancelMeReservationV1ResponseSuccess | cancelMeReservationV1ResponseError)

export const getCancelMeReservationV1Url = (id: string,) => {




  return `/api/v1/me/reservations/${id}/cancel`
}

/**
 * Cancels the reservation in the local database and propagates the cancellation to the origin system (Mews or SevenRooms). Only Confirmed reservations can be cancelled. Pending SevenRooms reservation requests cannot be cancelled (the SR API does not expose a cancel endpoint for requests); the frontend should hide the cancel button for Pending reservations.
 * @summary Cancel a reservation
 */
export const cancelMeReservationV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<cancelMeReservationV1Response> => {

  return customFetch<cancelMeReservationV1Response>(getCancelMeReservationV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type shareMeReservationV1Response200 = {
  data: ReservationShareDto
  status: 200
}

export type shareMeReservationV1Response401 = {
  data: void
  status: 401
}

export type shareMeReservationV1Response404 = {
  data: void
  status: 404
}

export type shareMeReservationV1ResponseSuccess = (shareMeReservationV1Response200) & {
  headers: Headers;
};
export type shareMeReservationV1ResponseError = (shareMeReservationV1Response401 | shareMeReservationV1Response404) & {
  headers: Headers;
};

export type shareMeReservationV1Response = (shareMeReservationV1ResponseSuccess | shareMeReservationV1ResponseError)

export const getShareMeReservationV1Url = (id: string,) => {




  return `/api/v1/me/reservations/${id}/share`
}

/**
 * Generates (or returns the existing) share code for the reservation. The code can be used to access the reservation via the public share link without authentication.
 * @summary Generate a share code for a reservation
 */
export const shareMeReservationV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<shareMeReservationV1Response> => {

  return customFetch<shareMeReservationV1Response>(getShareMeReservationV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type getMeCurrentStayV1Response200 = {
  data: ReservationSummaryDto
  status: 200
}

export type getMeCurrentStayV1Response204 = {
  data: void
  status: 204
}

export type getMeCurrentStayV1Response401 = {
  data: void
  status: 401
}

export type getMeCurrentStayV1ResponseSuccess = (getMeCurrentStayV1Response200 | getMeCurrentStayV1Response204) & {
  headers: Headers;
};
export type getMeCurrentStayV1ResponseError = (getMeCurrentStayV1Response401) & {
  headers: Headers;
};

export type getMeCurrentStayV1Response = (getMeCurrentStayV1ResponseSuccess | getMeCurrentStayV1ResponseError)

export const getGetMeCurrentStayV1Url = () => {




  return `/api/v1/me/reservations/current-stay`
}

/**
 * Checks whether the authenticated user has a Room reservation checked in right now, for the app to decide whether to show the "Home Estadia" alternate home screen. 200 with the reservation when one is in progress; 204 when not — absence is a normal state, not an error.
 * @summary Get the hotel stay currently in progress, if any
 */
export const getMeCurrentStayV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeCurrentStayV1Response> => {

  return customFetch<getMeCurrentStayV1Response>(getGetMeCurrentStayV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeUpcomingReservationsV1Response200 = {
  data: ReservationSummaryDto[]
  status: 200
}

export type getMeUpcomingReservationsV1Response401 = {
  data: void
  status: 401
}

export type getMeUpcomingReservationsV1ResponseSuccess = (getMeUpcomingReservationsV1Response200) & {
  headers: Headers;
};
export type getMeUpcomingReservationsV1ResponseError = (getMeUpcomingReservationsV1Response401) & {
  headers: Headers;
};

export type getMeUpcomingReservationsV1Response = (getMeUpcomingReservationsV1ResponseSuccess | getMeUpcomingReservationsV1ResponseError)

export const getGetMeUpcomingReservationsV1Url = (params?: GetMeUpcomingReservationsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/reservations/upcoming?${stringifiedParams}` : `/api/v1/me/reservations/upcoming`
}

/**
 * Returns the next upcoming reservations (Date >= today) ordered ascending by date, enriched with venue + service-category content from the CMS. Includes Pending reservation requests alongside confirmed bookings — a Pending row also appears in /me/reservation-requests.
 *
 * Query Parameters:
 * - take: Maximum items to return (default: 10, max: 50)
 * @summary Get current user's upcoming reservations
 */
export const getMeUpcomingReservationsV1 = async (params?: GetMeUpcomingReservationsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeUpcomingReservationsV1Response> => {

  return customFetch<getMeUpcomingReservationsV1Response>(getGetMeUpcomingReservationsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeSummaryV1Response200 = {
  data: AccountSummaryDto
  status: 200
}

export type getMeSummaryV1Response401 = {
  data: void
  status: 401
}

export type getMeSummaryV1ResponseSuccess = (getMeSummaryV1Response200) & {
  headers: Headers;
};
export type getMeSummaryV1ResponseError = (getMeSummaryV1Response401) & {
  headers: Headers;
};

export type getMeSummaryV1Response = (getMeSummaryV1ResponseSuccess | getMeSummaryV1ResponseError)

export const getGetMeSummaryV1Url = () => {




  return `/api/v1/me/summary`
}

/**
 * Returns summary statistics for the authenticated user (order counts, totals, membership)
 * @summary Get dashboard summary
 */
export const getMeSummaryV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeSummaryV1Response> => {

  return customFetch<getMeSummaryV1Response>(getGetMeSummaryV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


